import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/VccCredentials/EditorData";

const updateVccCredentialsEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_FETCHED:
      return { ...state, vccCredentialsEditorData: action.data };
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_COPIED:
      return { ...state, vccCredentialsEditorData: { ...action.data} };
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_UPDATED:
      return { ...state, vccCredentialsEditorData: { ...state.vccCredentialsEditorData, ...action.data } };
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.VCC_CREDENTIALS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.VCC_CREDENTIALS_EDITOR_SET_BOUND_ITEM:
      return {...state, vccCredentialsEditorData: {...state.vccCredentialsEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateVccCredentialsEditorData;
